import { useState, useEffect } from 'react';
import { useBorrowerEntityId } from '../../../../../queries/BorrowerFields/EntityFields';
import { DropDownBox } from '@apply/components';
import { LoanType } from '@apply/constants';
import { newBorrowerOptionText } from '@apply/ui';
import { EntityListResult } from '../interfaces/EntityListResult';

interface BorrowerDropDownProps {
    loanType: LoanType | null;
    entityList: EntityListResult | undefined;
    submitted?: boolean;
    onChange: (value: number) => void;
    isReview?: boolean;
    borrowerSelected?: boolean;
}

interface BorrowerListOptions {
    label: string;
    value: number;
    disabled: boolean;
}

export const BorrowerDropDown: React.FC<BorrowerDropDownProps> = ({
    loanType = null,
    entityList,
    onChange,
    isReview = false,
    borrowerSelected = true,
}) => {
    const [borrowerEntityId, set_borrowerEntityId] = useBorrowerEntityId();
    const [entitySelectList, set_entitySelectList] = useState<BorrowerListOptions[]>([]);

    useEffect(() => {
        const _loadBorrowerSelectList = async () => {
            const isLoc = loanType ? [LoanType.SubNoteConstruction, LoanType.SubNoteFixFlip].includes(loanType) : false;
            const ddListValues = isLoc
                ? entityList?.result.filter((e) => e.masterNoteId != null && e.masterNoteId > 0)
                : entityList?.result;

            const dropDownList: BorrowerListOptions[] =
                ddListValues?.map((borrower) => {
                    return {
                        label: `${borrower.entityName} (${borrower.entityStateIncorporated})`,
                        value: borrower.entityId,
                        disabled: false,
                    };
                }) || [];

            if (!isLoc) {
                //Add "New Borrower" option at the beginning
                dropDownList.unshift({
                    label: newBorrowerOptionText,
                    value: 0,
                    disabled: false,
                });
            }

            set_entitySelectList(dropDownList);
        };
        _loadBorrowerSelectList();
    }, [loanType, entityList]);

    return (
        <>
            {!isReview && (
                <DropDownBox
                    id='borrower'
                    value={borrowerSelected ? borrowerEntityId : null}
                    onChange={(entityId) => {
                        set_borrowerEntityId(entityId);
                        onChange(entityId);
                    }}
                    label='Select Borrower'
                    required={true}
                    dataSource={entitySelectList}
                    valueExpr='value'
                    displayExpr='label'
                />
            )}
        </>
    );
};
